export const validateCardExpiry = (cardExpiry) => {
    if (cardExpiry.length < 5) {
        return false;
    }
    if (!/^(0[1-9]|1[0-2])\/([0-9]{2})$/.test(cardExpiry)) {
        return false;
    }
    const [month, year] = cardExpiry.split('/');
    const today = new Date();
    const expiryYear = parseInt(`20${year}`, 10);
    const expiryMonth = parseInt(month, 10);
    if (expiryYear > today.getFullYear()) {
        return true;
    }
    if (expiryYear === today.getFullYear() && expiryMonth >= today.getMonth() + 1) {
        return true;
    }
    return false;
};
//# sourceMappingURL=validate-card-expiry.js.map